import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { listPortalChatCustomers } from "@/lib/portal.functions";
import { runServerFn } from "@/lib/server-fn";
import { PortalPageHeader } from "@/components/portal-shell";
import { ChatThread } from "@/components/chat-thread";
import { useState, useEffect } from "react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const Route = createFileRoute("/_authenticated/portal/chat")({ component: PortalChat });

function PortalChat() {
  const fetchCustomers = useServerFn(listPortalChatCustomers);
  const { data: customers = [] } = useQuery({
    queryKey: ["portal-chat-customers"],
    queryFn: () => runServerFn(() => fetchCustomers(), "Loading brands"),
  });

  const [selected, setSelected] = useState<string | null>(null);
  useEffect(() => {
    if (!selected && customers[0]) setSelected(customers[0].id);
  }, [customers, selected]);

  const active = customers.find((c) => c.id === selected);

  return (
    <>
      <PortalPageHeader
        title="Chat"
        description="Message your warehouse team."
        actions={customers.length > 1 ? (
          <Select value={selected ?? undefined} onValueChange={setSelected}>
            <SelectTrigger className="w-56"><SelectValue placeholder="Select brand" /></SelectTrigger>
            <SelectContent>
              {customers.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
            </SelectContent>
          </Select>
        ) : null}
      />
      <div className="p-4 sm:p-6">
        <div className="border rounded-lg bg-card h-[calc(100vh-220px)]">
          {active ? (
            <ChatThread tenantId={active.tenant_id} customerId={active.id} senderKind="portal" />
          ) : (
            <div className="h-full flex items-center justify-center text-sm text-muted-foreground">
              No brand assigned to your account yet.
            </div>
          )}
        </div>
      </div>
    </>
  );
}